import api from "@/services/api/api-cm"
import CMLocationConfigModel from "@/app/admin/modules/course_managment/classes/CMLocationConfigModel"

export default {
  namespaced: true,
  state: () => ({
    items: null,
    loading: false
  }),

  getters: {
    items: state => state.items
  },

  mutations: {
    set(state, items) {
      let formattedItems = items.map(item => new CMLocationConfigModel(item))
      state.items = formattedItems
    },

    update(state, {id, data}) {
      let itemIndex = state.items.findIndex(item => item.id === id)
      if(itemIndex < 0) return
      state.items[itemIndex].merge(data)
      // for(let field in state.items[itemIndex]) {
      //   state.items[itemIndex][field] = data[field]
      // }
    },

    startLoading(state) {
      state.loading = true
    },

    stopLoading (state) {
      state.loading = false
    },

    remove(state, configurationID) {
      let itemIndex = state.items.findIndex(item => item.id === configurationID)
      if(itemIndex < 0) return
      state.items.splice(itemIndex, 1)
    }
  },

  actions: {
    async list({state, commit}, params) {
      try {
        commit('startLoading')
        let res = await api.getCourseConfiguration(params.courseID)
        commit('set', res)
        return res
      } catch (error) {
        return Promise.reject(error)
      }
      finally {
        commit('stopLoading')
      }
    },

    async remove({commit}, params) {
      await api.removeConfiguration(params.courseID, params.configurationID)
      commit('remove', params.configurationID)
    }
  }
}
